var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.631 12.105c-.144.433-.499.764-.944.863-.935.206-1.878.36-2.825.464a3.2 3.2 0 01-5.725 0 26.414 26.414 0 01-2.825-.464c-.445-.098-.8-.43-.944-.863a2.908 2.908 0 01.703-2.976l.461-.461c.416-.416.59-1.02.462-1.593C2.281 3.868 4.715.8 8 .8c3.284 0 5.718 3.068 5.005 6.275a1.726 1.726 0 00.462 1.593l.462.461a2.909 2.909 0 01.702 2.976zM12.336 9.8l.461.461c.313.313.444.76.357 1.186-3.398.723-6.91.723-10.309 0a1.308 1.308 0 01.357-1.186l.462-.461a3.327 3.327 0 00.892-3.072C4.063 4.508 5.751 2.4 8 2.4c2.248 0 3.937 2.108 3.444 4.327a3.327 3.327 0 00.892 3.072z",
    fill: "#fff"
  })));
};
export default SvgNotification;